import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { InputField } from '../InputField';
import { Link } from '../Link';
import { CountdownTimer } from '../CountdownTimer';
import { EAlignment, FormFieldHelper } from '../FormFieldHelper';
import { FormFieldGroupLayout } from '../FieldGroupLayout';
import { EKeyCode } from '../../types/keyCodes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ConfirmationSmsCodeForm(_ref) {
  var isSubmitting = _ref.isSubmitting,
    handleSubmit = _ref.handleSubmit,
    submitButtonText = _ref.submitButtonText,
    code = _ref.code,
    codeRef = _ref.codeRef,
    onCodeChange = _ref.onCodeChange,
    codeError = _ref.codeError,
    isCodeInvalid = _ref.isCodeInvalid,
    lastResendTime = _ref.lastResendTime,
    resendAvailable = _ref.resendAvailable,
    resendTimeout = _ref.resendTimeout,
    onResend = _ref.onResend,
    onResendTimeoutExpired = _ref.onResendTimeoutExpired,
    buttons = _ref.buttons;
  var handleResendCode = React.useCallback(function (e) {
    e.preventDefault();
    if (onResend) {
      onResend(e);
    }
  }, [onResend]);
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handlePreventSubmit,
    children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
      content: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InputField, {
          "data-name": "CodeInput",
          autoComplete: "one-time-code",
          autoFocus: true,
          name: "code",
          ref: codeRef,
          value: code,
          onKeyDown: handleSubmitOnEnter,
          onChange: onCodeChange,
          disabled: isSubmitting,
          invalid: isCodeInvalid,
          errorMessage: codeError,
          placeholder: "\u041A\u043E\u0434"
        }), lastResendTime && resendTimeout ? /*#__PURE__*/_jsx(FormFieldHelper, {
          alignment: EAlignment.Left,
          marginBottom: true,
          children: /*#__PURE__*/_jsxs(Link, {
            href: "#",
            onClick: handleResendCode,
            disabled: !resendAvailable || isSubmitting,
            children: ["\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E", !resendAvailable && /*#__PURE__*/_jsx(CountdownTimer, {
              fromTimestamp: lastResendTime,
              timeout: resendTimeout,
              onTimeoutExpired: onResendTimeoutExpired,
              children: function children(_ref2) {
                var timeLeft = _ref2.timeLeft;
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [" \u0447\u0435\u0440\u0435\u0437 ", timeLeft, " \u0441\u0435\u043A."]
                });
              }
            })]
          })
        }) : null]
      }),
      buttons: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-name": "ConfirmCodeBtn",
          theme: "fill_primary",
          fullWidth: true,
          onClick: handleSubmit,
          loading: isSubmitting,
          disabled: isSubmitting,
          children: submitButtonText
        }), buttons]
      })
    })
  });
}